import {
  AnalyticsModeType,
  CalculatedEntriesState,
  ProductionCostEntryOrigin
} from './types';

export const initFilters = {
  busPartnerIds: [],
  lineNumbers: [],
  planningPeriods: {
    startDate: null,
    endDate: null
  },
  countryIds: [],
  name: '',
  statuses: [],
  origins: [ProductionCostEntryOrigin.Manual]
};

export const resetEntriesData = {
  page: 0,
  entries: [],
  absoluteValuesEntries: [],
  subtotals: {},
  absoluteValuesSubtotals: {},
  paginationOutput: {
    totalPages: null,
    totalRecords: null
  }
};

export const calculatedEntriesInitialState: CalculatedEntriesState = {
  filters: initFilters,
  entries: [],
  page: 0,
  analyticsMode: false,
  analyticsModeType: AnalyticsModeType.Overview,
  subtotals: {},
  absoluteValuesSubtotals: {},
  absoluteValuesEntries: [],
  paginationOutput: {
    totalPages: null,
    totalRecords: null
  },
  recordsPerPage: 10,
  isReloadData: false
};
